export default __webpack_public_path__ + "static/media/background-login.4e5ec23b.jpg";